import { lazy } from '@aboutyou/lazy-imports'
import { LoadingContainer } from '@aboutyou/legacy-shared/src/ui/utilityComponents/Loading/Loading'
import React from 'react'
import redial from 'redial'
import { redialDropDetails, redialDropOverview } from './redial'

const DropsOverviewPageAsync = lazy(() => import('./DropsOverviewPage'), {
  fallback: <LoadingContainer />,
})

const DropDetailsPageAsync = lazy(() => import('./DropDetailsPage'), {
  fallback: <LoadingContainer />,
})

export const DropsOverviewPage = redial.provideHooks(redialDropOverview)(() => (
  <DropsOverviewPageAsync />
))
export const DropDetailsPage = redial.provideHooks(redialDropDetails)(() => {
  return <DropDetailsPageAsync />
})
